// extracted by mini-css-extract-plugin
var _1 = "ChartItemLabel-modulelabel__hMN1y";
export { _1 as "label" }
